if (!customElements.get('sv-announcement')) {
  customElements.define('sv-announcement', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      const items = [...this.querySelectorAll('[data-sv-ann-item]')];
      let index = 0, hovered = false;
      const show = () => items.forEach((item, i) => { item.classList.toggle('is-active', i === index); item.inert = i !== index; item.setAttribute('aria-hidden', String(i !== index)); });
      const sync = () => {
        clearInterval(this.timer);
        if (!window.svMotion?.stopped() && !document.hidden && !this.hidden && !hovered && !this.contains(document.activeElement) && items.length > 1)
          this.timer = setInterval(() => { index = (index + 1) % items.length; show(); }, Number(this.dataset.svAnnSpeed) || 4000);
      };
      const close = this.querySelector('[data-sv-ann-close]');
      if (close) { close.hidden = false; close.addEventListener('click', () => { this.hidden = true; sync(); }, opts); }
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { hovered = true; sync(); } }, opts);
      this.addEventListener('pointerleave', () => { hovered = false; sync(); }, opts);
      this.addEventListener('focusin', sync, opts);
      this.addEventListener('focusout', () => queueMicrotask(() => this.isConnected && sync()), opts);
      document.addEventListener('sv:motionchange', sync, opts);
      document.addEventListener('visibilitychange', sync, opts);
      show(); sync();
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
  });
}
